import { useEffect, useState } from "react";
import { warnPackageInfoSelector } from "../../redux/warn-package.selector";

// Components imports
import { useSelector } from "react-redux";
import ButtonComponent from "../../../shared/components/button/button.component";
import DetailedBreakdownTableHeaderComponent from "../../../shared/components/detailed-breakdown-table-header.component";
import NoDataMessageComponent from "../../../shared/components/no-data-message/no-data-message.component";

//Interface import
import { WarnPackageDetailedBreakdownPropType } from "./warn-package-detailed-breakdown-interface";

/**
 * WarnPackageDetailedBreakdownComponent is a functional component that displays a detailed breakdown data.
 *
 * @component

 * @returns {React.JSX.Element}
 */

const WarnPackageDetailedBreakdownComponent = (): React.JSX.Element => {
    const warnPackageInfo = useSelector(warnPackageInfoSelector);

    const [propData, setPropData] = useState<
        WarnPackageDetailedBreakdownPropType[]
    >([]);
    const [improvedClass, setImprovedClass] = useState("bg-yellow");
    const [achievedClass, setAchievedClass] = useState("bg-primary-border");

    useEffect(() => {
        const initialData = warnPackageInfo?.warnPackageDBPropData.filter(
            (data) => !data?.meets && data?.meets !== null,
        );
        setPropData(initialData);
    }, [warnPackageInfo?.warnPackageDBPropData]);

    const setImprovePropData = () => {

        const newData = warnPackageInfo?.warnPackageDBPropData.filter(
            (data) => !data?.meets && data?.meets !== null,
        );
        setPropData(newData);
        setImprovedClass("bg-yellow");
        setAchievedClass("bg-primary-border");
    };

    const setAchievedPropData = () => {
        const newData = warnPackageInfo?.warnPackageDBPropData.filter(
            (data) => data?.meets && data?.meets !== null,
        );
        setPropData(newData);
        setImprovedClass("bg-primary-border");
        setAchievedClass("bg-yellow");
    };

    return (
        <div className="container mx-auto my-16">
            <div className="mx-4">
                <h2 className="hp-heading-color text-4xl border-b border-cyan-600">
                    Know your gaps
                </h2>
            </div>
            <div className="grid grid-cols-4 my-10 mx-4">
                <div className="col-span-4 lg:col-span-1 lg:mr-4 xl:mr-8">
                    <p>
                        Click on 'What has been achieved' and see the
                        characteristics of health warnings on cigarettes
                        packages that have already been achieved in your
                        country.
                        <br />
                        <br />
                        Click on 'Characteristics to improve' to see the policy
                        gaps in your country and the characteristics that have
                        not reached best-practice yet.
                    </p>
                    <div className="flex flex-col gap-2 p-2 button-box shadow-inner mr-4 mt-8">
                        <div onClick={setImprovePropData}>
                            <ButtonComponent
                                contentElement={
                                    <div>Characteristics to improve</div>
                                }
                                variantClass={improvedClass}
                            />
                        </div>

                        <div onClick={setAchievedPropData}>
                            <ButtonComponent
                                contentElement={
                                    <div>What has been achieved</div>
                                }
                                variantClass={achievedClass}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-span-4 lg:col-span-3 lg:ml-8 detailed-table">
                    <div className="detailed-whole-table">
                        <div>
                            <div className="grid grid-cols-7 justify-center overflow-hidden">
                                <div className="col-span-4"></div>
                                <div className="col-span-3 grid grid-cols-3 justify-center table-head text-center rounded-t-lg text-white">
                                    <DetailedBreakdownTableHeaderComponent
                                        text={"Cigarettes"}
                                    />
                                    <DetailedBreakdownTableHeaderComponent
                                        text={"Other smoked tobacco"}
                                    />
                                    <DetailedBreakdownTableHeaderComponent
                                        text={"Smokeless tobacco"}
                                    />
                                </div>
                            </div>

                            <ul className="shadow rounded-lg">
                                {propData.length === 0 ? (
                                    <NoDataMessageComponent />
                                ) : (
                                    propData.map((item) => (
                                        <li key={item?.id}>
                                            <div className="grid grid-cols-7 justify-center">
                                                <div className="col-span-4 mr-1 p-4 table-data bg-white">
                                                    {item?.heading}
                                                </div>
                                                <div className="col-span-1 mr-1 p-4 table-data font-bold text-center bg-white">
                                                    {item?.cigarettesText}
                                                </div>
                                                <div className="col-span-1 mr-1 p-4 table-data font-bold text-center bg-white">
                                                    {item?.smokedText}
                                                </div>
                                                <div className="col-span-1 mr-1 p-4 table-data font-bold text-center bg-white">
                                                    {item?.smokelessText}
                                                </div>
                                            </div>
                                        </li>
                                    ))
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WarnPackageDetailedBreakdownComponent;
